module.exports = __webpack_public_path__ + "media/images/service/a_1-417856289fb6e807a3bfd43596ab0c94.png";